// Dashboard-level APIs for Project Development
// Currently uses static responses / console logs; replace with real axios when backend is ready.

import axios from 'axios';
import { appUrl } from '../../../../../../utils/config';
import { getApiBaseUrl } from '../../CommonMethods/CommonMethods';

// Get base URL (same structure as other APIs in the application)
const apiBaseUrl = getApiBaseUrl(appUrl);

// ===== API FUNCTIONS =====

// Static data for dashboard (temporary)
const getStaticProjects = () => [
  {
    id: 1,
    cmoMfg: 'Patheon - Greenville',
    cmoSite: 'Patheon',
    cmoWorkOrderNumber: 'CMO12345',
    projectId: 'AB - 123',
    productDescription: 'Product X',
    poNumber: '1150345',
    batchNumber: '400682',
    batchId: 1,
    stage: 'NA',
    deliverableType: 'Manufacturing',
    poStatus: 'Completed',
    batchStatus: 'GRN Generated',
    projectStatus: 'Completed',
    campaignStatus: 'GRN Generated',
    completionDate: '2026-01-30',
    projectDetails: {
      campaigns: [
        {
          campaignId: 'CAMP-001',
          campaignID: 'CAMP-001',
          collabrixCampaignID: 1,
          campaignStatus: 'Completed',
          stages: [{ stageId: 'NA', stageName: 'NA', batches: [{ batchNumber: '400682', batchId: 1 }] }],
        },
      ],
    },
  },
  {
    id: 2,
    cmoMfg: 'Patheon - Greenville',
    cmoSite: 'Patheon',
    cmoWorkOrderNumber: 'CMO12346',
    projectId: 'AB - 234',
    productDescription: 'Product Y',
    poNumber: '1150344',
    batchNumber: '400681',
    batchId: 2,
    stage: 'NA',
    deliverableType: 'Manufacturing',
    poStatus: 'Confirmed',
    batchStatus: 'In-Progress',
    projectStatus: 'Confirmed',
    campaignStatus: 'In-Progress',
    completionDate: '2026-01-15',
    projectDetails: {
      campaigns: [
        {
          campaignId: 'CAMP-002',
          campaignID: 'CAMP-002',
          collabrixCampaignID: 2,
          campaignStatus: 'In-Progress',
          stages: [{ stageId: 'NA', stageName: 'NA', batches: [{ batchNumber: '400681', batchId: 2 }] }],
        },
      ],
    },
  },
  {
    id: 3,
    cmoMfg: 'Patheon - Greenville',
    cmoSite: 'Patheon',
    cmoWorkOrderNumber: 'CMO12347',
    projectId: 'AB - 345',
    productDescription: 'Product Z',
    poNumber: '1150343',
    batchNumber: '400680',
    batchId: 3,
    stage: 'NA',
    deliverableType: 'Manufacturing',
    poStatus: 'Created',
    batchStatus: 'Planned',
    projectStatus: 'Created',
    campaignStatus: 'Planned',
    completionDate: '2025-12-30',
    projectDetails: {
      campaigns: [
        {
          campaignId: 'CAMP-003',
          campaignID: 'CAMP-003',
          collabrixCampaignID: 3,
          campaignStatus: 'Planned',
          stages: [{ stageId: 'NA', stageName: 'NA', batches: [{ batchNumber: '400680', batchId: 3 }] }],
        },
      ],
    },
  },
  {
    id: 4,
    cmoMfg: 'Patheon - Greenville',
    cmoSite: 'Patheon',
    cmoWorkOrderNumber: 'CMO12348',
    projectId: 'AB - 456',
    productDescription: 'Product Z',
    poNumber: '1150342',
    batchNumber: '400679',
    batchId: 4,
    stage: 'NA',
    deliverableType: 'Manufacturing',
    poStatus: 'Under Confirmation',
    batchStatus: 'On Hold',
    projectStatus: 'Under Confirmation',
    campaignStatus: 'On Hold',
    completionDate: '2025-12-15',
    projectDetails: {
      campaigns: [
        {
          campaignId: 'CAMP-004',
          campaignID: 'CAMP-004',
          collabrixCampaignID: 4,
          campaignStatus: 'On Hold',
          stages: [{ stageId: 'NA', stageName: 'NA', batches: [{ batchNumber: '400679', batchId: 4 }] }],
        },
      ],
    },
  },
  {
    id: 5,
    cmoMfg: 'Patheon - Greenville',
    cmoSite: 'Patheon',
    cmoWorkOrderNumber: 'CMO12349',
    projectId: 'AB - 567',
    productDescription: 'Product A',
    poNumber: '1150341',
    batchNumber: '400678',
    batchId: 5,
    stage: 'NA',
    deliverableType: 'Manufacturing',
    poStatus: 'Confirmed',
    batchStatus: 'GRN Generated',
    projectStatus: 'Confirmed',
    campaignStatus: 'GRN Generated',
    completionDate: '2025-12-01',
    projectDetails: {
      campaigns: [
        {
          campaignId: 'CAMP-005',
          campaignID: 'CAMP-005',
          collabrixCampaignID: 5,
          campaignStatus: 'GRN Generated',
          stages: [{ stageId: 'NA', stageName: 'NA', batches: [{ batchNumber: '400678', batchId: 5 }] }],
        },
      ],
    },
  },
];

const getStaticQuickSummary = () => [
  { statusName: 'New POs without Planned Batches', count: 8 },
  { statusName: 'Planned Batches', count: 8 },
  { statusName: 'Batches Pending CMO Release', count: 8 },
  { statusName: 'Batches Pending Sponsor Release', count: 8 },
  { statusName: 'Batches With Packaging Completed', count: 8 },
  { statusName: 'Batches Delayed', count: 8 },
  { statusName: 'Batches with New Comments', count: 8 },
];

export const fetchProjectsAPI = async (params = {}, cmoSitesList = [], deliverableTypesList = []) => {
  console.log('[Dashboard] Fetching projects with params:', params);

  // ===== STATIC DATA (commented out — using real API below) =====
  // const allProjects = getStaticProjects();
  // const statusFilterMap = {
  //   'Ongoing Projects':   p => p.projectStatus === 'In-Progress' || p.campaignStatus === 'Ongoing',
  //   'Inactive Projects':  p => p.projectStatus === 'Created'     || p.campaignStatus === 'Inactive',
  //   'Required Action':    p => p.projectStatus === 'Initiated'   || p.campaignStatus === 'Pending',
  //   'Delayed Projects':   p => p.projectStatus === 'On-Hold'     || p.campaignStatus === 'Delayed',
  //   'Completed Projects': p => p.projectStatus === 'Completed'   || p.campaignStatus === 'Complete',
  // };
  // const filterFn = params.projectStatusID && statusFilterMap[params.projectStatusID];
  // const filteredProjects = filterFn ? allProjects.filter(filterFn) : allProjects;
  //
  // return {
  //   status: true,
  //   projects: filteredProjects,
  //   totalProjects: filteredProjects.length,
  // };

  try {
    // Helper function to convert cmoSite text to ID or "all"
    const getCmoSiteID = (cmoSiteText) => {
      if (!cmoSiteText || cmoSiteText === 'all') return 'all';
      // If cmoSitesList contains objects, find the matching one
      const matched = cmoSitesList.find(site => {
        if (typeof site === 'object' && site?.siteNameFromReport) {
          return site.siteNameFromReport === cmoSiteText;
        }
        return site === cmoSiteText;
      });
      // Return vendorMosymphonyID if found, otherwise try to parse as number
      if (matched && typeof matched === 'object' && matched.vendorMosymphonyID) {
        return matched.vendorMosymphonyID;
      }
      // If it's already a number, return it
      const numValue = Number(cmoSiteText);
      return isNaN(numValue) ? 'all' : numValue;
    };

    // Helper function to convert deliverableType text to ID or "all"
    const getDeliverableTypeID = (deliverableTypeText) => {
      if (!deliverableTypeText || deliverableTypeText === 'all') return 'all';
      // If deliverableTypesList contains objects, find the matching one
      const matched = deliverableTypesList.find(type => {
        if (typeof type === 'object' && type?.deliverableTypeName) {
          return type.deliverableTypeName === deliverableTypeText;
        }
        return type === deliverableTypeText;
      });
      // Return deliverableTypeID if found, otherwise try to parse as number
      if (matched && typeof matched === 'object' && matched.deliverableTypeID) {
        return matched.deliverableTypeID;
      }
      // If it's already a number, return it
      const numValue = Number(deliverableTypeText);
      return isNaN(numValue) ? 'all' : numValue;
    };

    // Build payload for fetchProjectDashboard API
    // When "all" is selected, send "all" string for cdmoOrgID and deliverableTypeID
    const payload = {
      cdmoOrgID: getCmoSiteID(params.cmoSite),
      deliverableTypeID: getDeliverableTypeID(params.deliverableType),
      searchByField: params.searchCriteria && params.searchCriteria !== 'all' ? params.searchCriteria : null,
      searchValue: params.searchValue || null,
      // Map projectStatusID from quick summary to viewProjectOption
      // If projectStatusID is provided, map it to the corresponding status
      // Otherwise default to lowercase "all"
      viewProjectOption: params.projectStatusID ? 
        (Array.isArray(params.projectStatusID) ? 
          (params.projectStatusID.includes(1) ? 'Ongoing' : 
           params.projectStatusID.includes(2) ? 'Inactive' :
           params.projectStatusID.includes(3) ? 'Required Action' :
           params.projectStatusID.includes(4) ? 'Delayed' :
           params.projectStatusID.includes(5) ? 'Completed' : 'all') : 'all') : 'all',
      pageSize: params.pageSize || 10,
      pageNumber: params.pageNumber || 1,
    };

    console.log('[Dashboard] Project Dashboard API Payload:', payload);

    const response = await axios.post(`${apiBaseUrl}/fetchProjectDashboard`, payload);
    
    // Middleware response: { status, data: { data: [ ... ] } }
    // Corda response: { status, statusCode, data: [ ... ] }
    const rawData =
      (response?.data?.data && Array.isArray(response.data.data.data) && response.data.data.data) ||
      (response?.data?.data && Array.isArray(response.data.data) && response.data.data) ||
      (Array.isArray(response?.data?.data) && response.data.data) ||
      (Array.isArray(response?.data) && response.data) ||
      [];

    if (response?.data?.status && Array.isArray(rawData)) {
      // Map API response to dashboard format
      const projects = rawData.map(project => {
        // Derive PO number: prefer top-level, else from first campaign that has one
        const campaignsArray = project.campaigns || [];
        const campaignWithPo = campaignsArray.find(c => c?.poNumber);
        const derivedPoNumber = project.poNumber || (campaignWithPo ? campaignWithPo.poNumber : '');

        // Derive deliverable type display value (supporting multiple types)
        let derivedDeliverableType = '';

        // 1) If API already sends a human-readable deliverableType, prefer it
        if (project.deliverableType) {
          derivedDeliverableType = project.deliverableType;
        } else if (Array.isArray(project.deliverableTypes) && project.deliverableTypes.length > 0) {
          // 2) If API sends an array of deliverableTypes, join their names
          const names = project.deliverableTypes
            .map(dt => dt?.deliverableTypeName || dt?.deliverableType || dt)
            .filter(Boolean);
          derivedDeliverableType = names.join(', ');
        } else if (project.deliverableTypeIDs && Array.isArray(deliverableTypesList) && deliverableTypesList.length > 0) {
          // 3) If we only have IDs, map them to names using deliverableTypesList
          const idToNameMap = {};
          deliverableTypesList.forEach(dt => {
            if (dt?.deliverableTypeID != null && dt?.deliverableTypeName) {
              idToNameMap[String(dt.deliverableTypeID)] = dt.deliverableTypeName;
            }
          });

          const ids = String(project.deliverableTypeIDs)
            .split(',')
            .map(id => id && id.trim())
            .filter(Boolean);

          const names = ids
            .map(id => idToNameMap[id])
            .filter(Boolean);

          derivedDeliverableType = names.join(', ');
        }

        // Transform campaigns structure to match UI expectations
        const transformedCampaigns = campaignsArray.map(campaign => {
          // Transform campaignStageDetails to stages
          const stages = (campaign.campaignStageDetails || []).map(stageDetail => {
            // Transform deliveryScheduleBatches to batches
            const batches = (stageDetail.deliveryScheduleBatches || []).map(batch => ({
              batchNumber: batch.vendorBatchNumber || batch.batchNumber || '',
              batchId: batch.schrockenDeliveryScheduleBatchID || batch.batchID || null,
              // Include other batch properties if needed
              ...batch,
            }));

            return {
              stageId: stageDetail.cmoStageID || '',
              stageName: stageDetail.cmoStageID || '',
              batches: batches,
              // Include other stage properties if needed
              ...stageDetail,
            };
          });

          return {
            campaignId: campaign.campaignID || '',
            campaignID: campaign.campaignID || '', // Keep both for compatibility
            collabrixCampaignID: campaign.collabrixCampaignID || null,
            campaignStatus: campaign.campaignStatus || '',
            stages: stages,
            // Include other campaign properties
            ...campaign,
          };
        });

        return {
          id: project.projectID,
          // Keep existing cmoSite field (used in UI filters) and also expose cmoOrgName if available
          cmoSite: project.cdmoOrgID || '',
          cmoOrgID: project.cdmoOrgID || '',
          cmoOrgName: project.cdmoOrgName || '',
          projectId: project.projectID?.toString() || derivedPoNumber,
          productDescription: project.productDescription || '',
          poNumber: derivedPoNumber,
          campaignId: transformedCampaigns?.[0]?.campaignId || '',
          cmoStage: transformedCampaigns?.[0]?.stages?.[0]?.stageId || '',
          cmoBatchNumber: transformedCampaigns?.[0]?.stages?.[0]?.batches?.map(b => b.batchNumber).join(', ') || '',
          // Show a comma-separated list of deliverable type names when available
          deliverableType: derivedDeliverableType,
          projectStatus: project.projectStatus || '',
          campaignStatus: transformedCampaigns?.[0]?.campaignStatus || '',
          completionDate: project.completionDate || '',
          projectDetails: {
            campaigns: transformedCampaigns,
          },
          // Spread any additional project-level properties from API
          ...project,
        };
      });

      return {
        status: true,
        projects: projects,
        totalProjects: projects.length,
      };
    }

    return {
      status: false,
      projects: [],
      totalProjects: 0,
    };
  } catch (error) {
    console.error('[Dashboard] Error fetching projects:', error);
    return {
      status: false,
      projects: [],
      totalProjects: 0,
    };
  }
};

export const getQuickSummaryStatuses = async (filters = {}, cmoSitesList = [], deliverableTypesList = []) => {
  console.log('[Dashboard] Fetching quick summary tiles with filters:', filters);

  // ===== STATIC DATA (commented out — using real API below) =====
  // return {
  //   status: true,
  //   quickSummaryStatuses: getStaticQuickSummary(),
  // };

  try {
    const appName = localStorage.getItem("appName");
    const network = localStorage.getItem("network");
    const collabType = localStorage.getItem("collabType");
    const roleName = localStorage.getItem("roleName");

    if (!appName || !network || !collabType || !roleName) {
      throw new Error("Missing required localStorage values for API call");
    }

    const apiBaseUrl = `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;

    // Helper function to convert cmoSite text to ID or "all"
    const getCmoSiteID = (cmoSiteText) => {
      if (!cmoSiteText || cmoSiteText === 'all') return 'all';
      // If cmoSitesList contains objects, find the matching one
      const matched = cmoSitesList.find(site => {
        if (typeof site === 'object' && site?.siteNameFromReport) {
          return site.siteNameFromReport === cmoSiteText;
        }
        return site === cmoSiteText;
      });
      // Return vendorMosymphonyID if found, otherwise try to parse as number
      if (matched && typeof matched === 'object' && matched.vendorMosymphonyID) {
        return matched.vendorMosymphonyID;
      }
      // If it's already a number, return it
      const numValue = Number(cmoSiteText);
      return isNaN(numValue) ? 'all' : numValue;
    };

    // Helper function to convert deliverableType text to ID or "all"
    const getDeliverableTypeID = (deliverableTypeText) => {
      if (!deliverableTypeText || deliverableTypeText === 'all') return 'all';
      // If deliverableTypesList contains objects, find the matching one
      const matched = deliverableTypesList.find(type => {
        if (typeof type === 'object' && type?.deliverableTypeName) {
          return type.deliverableTypeName === deliverableTypeText;
        }
        return type === deliverableTypeText;
      });
      // Return deliverableTypeID if found, otherwise try to parse as number
      if (matched && typeof matched === 'object' && matched.deliverableTypeID) {
        return matched.deliverableTypeID;
      }
      // If it's already a number, return it
      const numValue = Number(deliverableTypeText);
      return isNaN(numValue) ? 'all' : numValue;
    };

    // Build payload for fetchProjectQuickSummaryTiles API
    const payload = {
      cdmoOrgID: getCmoSiteID(filters.cmoSite),
      deliverableTypeID: getDeliverableTypeID(filters.deliverableType),
    };

    console.log('[Dashboard] Quick Summary API Payload:', payload);

    const response = await axios.post(`${apiBaseUrl}/fetchProjectQuickSummaryTiles`, payload);

    if (response?.data?.status === true || response?.data?.status === "true") {
      const data = response.data?.data || {};
      
      // Map API response to expected format
      const quickSummaryStatuses = [
        { statusName: 'Ongoing Projects', count: data.onGoingProjects || 0 },
        { statusName: 'Inactive Projects', count: data.projectsInActive || 0 },
        { statusName: 'Required Action', count: data.projectsRequiredAction || 0 },
        { statusName: 'Delayed Projects', count: data.projectsDelayed || 0 },
        { statusName: 'Completed Projects', count: data.projectsCompleted || 0 },
      ];

      return {
        status: true,
        quickSummaryStatuses: quickSummaryStatuses,
      };
    }

    // Fallback to empty data if API fails
    return {
      status: false,
      quickSummaryStatuses: [
        { statusName: 'Ongoing Projects', count: 0 },
        { statusName: 'Inactive Projects', count: 0 },
        { statusName: 'Required Action', count: 0 },
        { statusName: 'Delayed Projects', count: 0 },
        { statusName: 'Completed Projects', count: 0 },
      ],
    };
  } catch (error) {
    console.error('[Dashboard] Error fetching quick summary tiles:', error);
    // Return empty data on error
    return {
      status: false,
      quickSummaryStatuses: [
        { statusName: 'Ongoing Projects', count: 0 },
        { statusName: 'Inactive Projects', count: 0 },
        { statusName: 'Required Action', count: 0 },
        { statusName: 'Delayed Projects', count: 0 },
        { statusName: 'Completed Projects', count: 0 },
      ],
    };
  }
};

export const updateProjectAndCampaignStatus = async (params = {}) => {
  console.log('Updating project/campaign status with params:', params);

  // Example real call:
  // const response = await axios.post(`${apiBaseUrl}/updateProjectAndCampaignStatus`, params);
  // return response.data;

  return {
    status: true,
    message: 'Status updated successfully (mock)',
  };
};

export const fetchActiveBatchesAPI = async (params = {}) => {
  console.log('[Dashboard] Fetching active batches (mock) with params:', params);

  // Real API (to enable later):
  // Method: POST
  // Endpoint: /fetchActiveBatchesAPI
  // Payload example:
  // {
  //   cmoSite: "Sai - HYD",
  //   deliverableType: "Manufacturing"
  // }
  //
  // const response = await axios.post(`${apiBaseUrl}/fetchActiveBatchesAPI`, {
  //   cmoSite: params.cmoSite,
  //   deliverableType: params.deliverableType,
  // });
  // return response.data;

  // Static mock response — sourced from BMS_Data_Final_27032026.xlsx
  return {
    status: true,
    message: 'Active batches fetched successfully',
    data: {
      activeBatches: [
        {
          batchNumber: 'DBSQC26008',
          cmoSite: 'Sai - Unit-IV',
          projectId: '13762',
          productDescription: 'BSQ Stage-C',
          cmoStage: 'Stage C',
          chemicalNumber: '(MIR-006432)',
          completed: 'DSSR57, DGLB05, DSCF23',
          ongoing: 'DSCF18, DRVD08',
          onHold: '',
          timestamp: '12-MAR-2026 17:15:42',
        },
        {
          batchNumber: 'DBSQC26011',
          cmoSite: 'Sai - Unit-IV',
          projectId: '13762',
          productDescription: 'BSQ Stage-C',
          cmoStage: 'Stage C',
          chemicalNumber: '(MIR-006432)',
          completed: 'DGLR64, DGLB04-1, DSCF15',
          ongoing: 'DRVD08',
          onHold: '',
          timestamp: '24-MAR-2026 07:14:56',
        },
        {
          batchNumber: 'DBSQC26012',
          cmoSite: 'Sai - Unit-IV',
          projectId: '13762',
          productDescription: 'BSQ Stage-C',
          cmoStage: 'Stage C',
          chemicalNumber: '(MIR-006432)',
          completed: 'DSSR57, DGLB05, DSCF23',
          ongoing: 'DSCF18, DRVD08',
          onHold: '',
          timestamp: '26-MAR-2026 15:20:25',
        },
      ],
    },
  };
};


